const isProduction = process.env.NODE_ENV === 'production' ? true : false;
const isStage = process.env.NODE_ENV === 'stage' ? true : false;
const EXCEL_TEMPLATE_METADATA_FIELDS = ['PhotoID', 'Squadra', 'Categoria', 'Nome', 'Cognome'];
const EXCEL_TEMPLATE_FILENAME = 'project_metadata_template';
const EXCEL_METADATA_FILENAME='metadati_photoselfie';
const EXCEL_CALENDARIO_FILENAME='calendar_data_photoselfie';
const S3_URL = isProduction ? 'https://s3.amazonaws.com/akinda-footprint/photoselfie' : isStage ? 'https://s3.amazonaws.com/test-akinda-footprint/photoselfie' : 'https://s3.amazonaws.com/dev-akinda-footprint/photoselfie';
const PHOTOSELFIE_BASE_URL = isProduction ? 'https://photoselfie.akinda.com' : isStage ? "http://photoselfie.akinda.it" : "http://localhost:3000";
const landing_page_max_photo_size = 10485760 ;
const landing_page_min_photo_size = 1048576 ;
const calendar_sponsor_min_photo_size = 524288;
const calendar_sponsor_max_photo_size = 10485760;
const calendar_min_photo_size = 2621440;
const calendar_max_photo_size = 10485760;


const PRIVACY_URL = isProduction ? 'http://it.akinda.com/' : isStage ? 'http://it.akinda.com/' : 'http://it.akinda.com/';
const API_URL = isProduction ? "https://api.akinda.com" : isStage ? "http://api-test.akinda.com" : "http://api-dev.akinda.com";
const GOOGLE_MAPS_URL = "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBmbV0G-fLDTZwK6py6o5y-wPPrcAV7I70&type=address&address=";
const FORM_BILLING_URL = isProduction ? "https://fatturazione.akinda.com/" : isStage ? "http://fatturazione.akinda.it/" : "http://fatturazione.akinda.it/";


const MERCHANT_AKINDA_STORE_URL = isProduction ? "https//myshop.akinda.com/home/" : isStage ? "http://myshop.akinda.it/home/" : "http://myshop.akinda.it/home/";
const DEFAULT_TEXT = {
    my_billing_address: "INDIRIZZI DI FATTURAZIONE",
    my_shipment_address: "INDIRIZZI DI SPEDIZIONE",
    maintenance_mode_title: "Sito in Manutenzione!",
    maintenance_mode_description: "Stiamo lavorando per migliorare il servizio.",
};

const DEFAULT_COLORS = {
    primary: "#bdd002",
    secondary: "#242424",
    primary_text: "#ffffff",
    secondary_text: "#999999",
    red: "#e52441",
    orange: "#f8701c",
    green: "#3baa34",
    black: "#2a2a2a",
    white: "#ffffff",
    'custom': "9C27B0",
};

const AKINDA_COLORS = [
    '#ee8a3f',
    '#4bb3e9',
    '#242c6d',
    '#e3c644',
    '#8f2227',
    '#727775',
    '#dc94a2',
    '#c4393e',
    '#6c964e',
    '#2c5c46',
    '#62347c',
    '#aa874d',
    '#ffffff',
    '#000000',
];

const LANGUAGES_COUNTRY = {
    'it': 'italia',
    'de': 'germania',
    'at': 'austria',
    'es': 'spagna',
    'fr': 'francia',
    'en': 'inghilterra',
    'ch': 'svizzera',
    'ii': 'svizzera',
    'ff': 'svizzera',
    'be': 'belgio',
};

const DEFAULT_IMAGES = {
    logo: S3_URL + "/others/logo-publishing.png",
};

const NOMAIL = "nomail@akinda.com";

const provinces = [
    {sigla: 'AG', province: 'Agrigento'},
    {sigla: 'AL', province: 'Alessandria'},
    {sigla: 'AN', province: 'Ancona'},
    {sigla: 'AO', province: 'Aosta'},
    {sigla: 'AQ', province: "L'Aquila"},
    {sigla: 'AR', province: 'Arezzo'},
    {sigla: 'AP', province: 'Ascoli-Piceno'},
    {sigla: 'AT', province: 'Asti'},
    {sigla: 'AV', province: 'Avellino'},
    {sigla: 'BA', province: 'Bari'},
    {sigla: 'BT', province: 'Barletta Andria Trani'},
    {sigla: 'BL', province: 'Belluno'},
    {sigla: 'BN', province: 'Benevento'},
    {sigla: 'BG', province: 'Bergamo'},
    {sigla: 'BI', province: 'Biella'},
    {sigla: 'BO', province: 'Bologna'},
    {sigla: 'BZ', province: 'Bolzano'},
    {sigla: 'BS', province: 'Brescia'},
    {sigla: 'BR', province: 'Brindisi'},
    {sigla: 'CA', province: 'Cagliari'},
    {sigla: 'CL', province: 'Caltanisseta'},
    {sigla: 'CB', province: 'Campobasso'},
    {sigla: 'ci', province: 'Carbonia Iglesias'},
    {sigla: 'ce', province: 'Caserta'},
    {sigla: 'ct', province: 'Catania'},
    {sigla: 'cz', province: 'Catanzaro'},
    {sigla: 'ch', province: 'Chieti'},
    {sigla: 'co', province: 'Como'},
    {sigla: 'cs', province: 'Cosenza'},
    {sigla: 'cr', province: 'Cremona'},
    {sigla: 'kr', province: 'Crotone'},
    {sigla: 'cn', province: 'Cuneo'},
    {sigla: 'en', province: 'Enna'},
    {sigla: 'fm', province: 'Fermo'},
    {sigla: 'fe', province: 'Ferrara'},
    {sigla: 'fi', province: 'Firenze'},
    {sigla: 'fg', province: 'Foggia'},
    {sigla: 'fc', province: 'Forli Cesena'},
    {sigla: 'fr', province: 'Frosinone'},
    {sigla: 'ge', province: 'Genova'},
    {sigla: 'go', province: 'Gorizia'},
    {sigla: 'gr', province: 'Grosseto'},
    {sigla: 'im', province: 'Imperia'},
    {sigla: 'is', province: 'Isernia'},
    {sigla: 'sp', province: 'La-Spezia'},
    {sigla: 'lt', province: 'Latina'},
    {sigla: 'le', province: 'Lecce'},
    {sigla: 'lc', province: 'Lecco'},
    {sigla: 'li', province: 'Livorno'},
    {sigla: 'lo', province: 'Lodi'},
    {sigla: 'lu', province: 'Lucca'},
    {sigla: 'mc', province: 'Macerata'},
    {sigla: 'mn', province: 'Mantova'},
    {sigla: 'ms', province: 'Massa Carrara'},
    {sigla: 'mt', province: 'Matera'},
    {sigla: 'vs', province: 'Medio Capidano'},
    {sigla: 'me', province: 'Messina'},
    {sigla: 'mi', province: 'Milano'},
    {sigla: 'mo', province: 'Modena'},
    {sigla: 'mb', province: 'Monza Brianza'},
    {sigla: 'na', province: 'Napoli'},
    {sigla: 'no', province: 'Novara'},
    {sigla: 'nu', province: 'Nuoro'},
    {sigla: 'og', province: 'Ogliastra'},
    {sigla: 'ot', province: 'Olbia Tempio'},
    {sigla: 'or', province: 'Oristano'},
    {sigla: 'pd', province: 'Padova'},
    {sigla: 'pa', province: 'Palermo'},
    {sigla: 'pr', province: 'Parma'},
    {sigla: 'pv', province: 'Pavia'},
    {sigla: 'pg', province: 'Perugia'},
    {sigla: 'pu', province: 'Pesaro Urbino'},
    {sigla: 'pe', province: 'Pescara'},
    {sigla: 'pc', province: 'Piacenza'},
    {sigla: 'pi', province: 'Pisa'},
    {sigla: 'pt', province: 'Pistoia'},
    {sigla: 'pn', province: 'Pordenone'},
    {sigla: 'pz', province: 'Potenza'},
    {sigla: 'po', province: 'Prato'},
    {sigla: 'rg', province: 'Ragusa'},
    {sigla: 'ra', province: 'Ravenna'},
    {sigla: 'rc', province: 'Reggio Calabria'},
    {sigla: 're', province: 'Reggio Emilia'},
    {sigla: 'ri', province: 'Rieti'},
    {sigla: 'rn', province: 'Rimini'},
    {sigla: 'rm', province: 'Roma'},
    {sigla: 'ro', province: 'Rovigo'},
    {sigla: 'sa', province: 'Salerno'},
    {sigla: 'ss', province: 'Sassari'},
    {sigla: 'sv', province: 'Savona'},
    {sigla: 'si', province: 'Siena'},
    {sigla: 'sr', province: 'Siracusa'},
    {sigla: 'so', province: 'Sondrio'},
    {sigla: 'ta', province: 'Taranto'},
    {sigla: 'te', province: 'Teramo'},
    {sigla: 'tr', province: 'Terni'},
    {sigla: 'to', province: 'Torino'},
    {sigla: 'tp', province: 'Trapani'},
    {sigla: 'tn', province: 'Trento'},
    {sigla: 'tv', province: 'Treviso'},
    {sigla: 'ts', province: 'Trieste'},
    {sigla: 'ud', province: 'Udine'},
    {sigla: 'va', province: 'Varese'},
    {sigla: 've', province: 'Venezia'},
    {sigla: 'vb', province: 'Verbania'},
    {sigla: 'vc', province: 'Vercelli'},
    {sigla: 'vr', province: 'Verona'},
    {sigla: 'vv', province: 'Vibo Valentia'},
    {sigla: 'vi', province: 'Vicenza'},
    {sigla: 'vt', province: 'Viterbo'},
];

export {
    isProduction,
    isStage,
    API_URL,
    DEFAULT_TEXT,
    NOMAIL,
    DEFAULT_IMAGES,
    provinces,
    DEFAULT_COLORS,
    S3_URL,
    AKINDA_COLORS,
    MERCHANT_AKINDA_STORE_URL,
    LANGUAGES_COUNTRY,
    GOOGLE_MAPS_URL,
    FORM_BILLING_URL,
    PHOTOSELFIE_BASE_URL,
    EXCEL_TEMPLATE_METADATA_FIELDS,
    EXCEL_TEMPLATE_FILENAME,
    PRIVACY_URL,
    // LANDING_PAGE_URL,
    EXCEL_METADATA_FILENAME,
    EXCEL_CALENDARIO_FILENAME,
    landing_page_max_photo_size,
    landing_page_min_photo_size,
    calendar_sponsor_max_photo_size,
    calendar_sponsor_min_photo_size,
    calendar_max_photo_size,
    calendar_min_photo_size

};



// WEBPACK FOOTER //
// ./src/utils/constants.js